export default "__VITE_ASSET__CsEnn$pu__"